<template>
  <div class="row">
    <!-- md-hidden -->
    <div v-for="(item, index) in dataList" :key="index" :class="['md-hidden', `col-lg-${item.col}`]">
      <div v-if="item.type == 'text'">
        <h1 class="font-weight-bold pb-3 pt-4 title-main display-inline-block">{{ item.title }}</h1>
        <retract-list :dataList="item.content"></retract-list>
      </div>
      <div v-else>
        <img :src="item.src" class="image-width-100" />
      </div>
    </div>
    <!-- lg-hidden -->
    <div class="lg-hidden">
      <div v-if="dataList[0].type == 'text'">
        <h1 class="font-weight-bold pb-3 pt-4 title-main display-inline-block">{{ dataList[0].title }}</h1>
        <retract-list :dataList="dataList[0].content"></retract-list>
        <img :src="dataList[1].src" class="image-width-100" />
      </div>
      <div v-else>
        <h1 class="font-weight-bold pb-3 pt-4 title-main display-inline-block">{{ dataList[1].title }}</h1>
        <retract-list :dataList="dataList[1].content"></retract-list>
        <img :src="dataList[0].src" class="image-width-100" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutList',
  components: {},
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      },
    },
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
}
</script>
<style scoped>
@media (max-width: 768px) {
  .row {
    line-height: 2;
  }
}
@media (min-width: 768px) {
  .row {
    line-height: 3;
  }
}
</style>
